// extracted by mini-css-extract-plugin
module.exports = {"items-2":"ToggleMenu_items-2__7Sw1y","items-3":"ToggleMenu_items-3__8FhZ2","items-4":"ToggleMenu_items-4__GU9h5","items-5":"ToggleMenu_items-5__sc6r0"};